module.exports = __webpack_public_path__ + "static/media/arbutus-115-min.f43e6b77.jpg";